import React from 'react'
import ReactModal from "react-modal"
import { inject, observer } from "mobx-react"
import styled from "styled-components"
import { withRouter } from "next/router"
import MockLink from "../MockLink"
import MODAL_STYLES from "~/components/modals/styles"
import Spacer from "~/components/Spacer"
import WinItButton from "~/components/WinItButton"
import LabeledSimpleInput from "~/components/Form/LabeledSimpleInput"

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const ModalTitle = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  font-size: 1.5em;
  text-align: center;
  max-width: 550px;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
`

const ModalDiv = styled.div`
  padding: 0 1rem 0 1rem;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  auth: all.store.auth,
  user: all.store.auth.user,
  isLoggedIn: all.store.auth.isLoggedIn,
  isPaymentInProcess: all.store.payment.isLoading,
  setPhoneVerifyModalShowing: all.store.ui.setPhoneVerifyModalShowing,
  phoneVerifyModalShowing: all.store.ui.phoneVerifyModalShowing,
  addToast: all.store.ui.toasts.addToast
}))
@observer
class PhoneVerificationModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sentCode: false,
      confirmationCode: '',
      errorMessage: '',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLoggedIn === false && this.props.isLoggedIn === true && this.props.user.phoneNumber && this.props.user.phoneNumber !== '' && !this.props.user.phoneNumberVerified && !this.props.isPaymentInProcess) {
      this.props.setPhoneVerifyModalShowing(true)
    }
  }

  handleConfirmationCodeChange = (e) => {
    this.setState({ confirmationCode: e.target.value })
  }

  hideModal = () => {
    this.props.setPhoneVerifyModalShowing(false)
  }

  goToDashboard = () => {
    this.props.router.push('/dashboard/profile')
    this.props.setPhoneVerifyModalShowing(false)
  }

  goToContactSupport = () => {
    this.props.router.push('/contact')
    this.props.setPhoneVerifyModalShowing(false)
  }

  sendVerificationCode = async (event) => {
    if (event && event.preventDefault) event.preventDefault()
    try {
      await this.props.auth.sendPhoneNumberVerificationCode()
      this.setState({ sentCode: true })
    } catch (e) {
      this.props.addToast({ message: e, type: "ERROR" })
      this.setState({ sentCode: false })
    }
  }

  handleSubmit = async (event) => {
    if (event && event.preventDefault) event.preventDefault()
    const { auth } = this.props
    if (this.state.confirmationCode.trim() === "") {
      this.setState({ errorMessage: "Please enter a code!" })
      return
    }
    try {
      const result = await auth.checkPhoneNumberVerificationCode(this.state.confirmationCode)
      if (result.valid) {
        this.setState({ confirmationCode: '', errorMessage: '', sentCode: false })
        this.props.user.changeKey('phoneNumberVerified', true)
        this.props.addToast({ message: 'Thanks for verifying your phone number', type: 'SUCCESS' })
        this.hideModal()
      } else {
        this.setState({ errorMessage: 'Invalid code, please try again.' })
      }
    } catch (e) {
      this.props.addToast({ message: e, type: "ERROR" })
    }
  }

  render() {
    return (
      <ReactModal
        closeTimeoutMS={300}
        isOpen={this.props.phoneVerifyModalShowing}
        style={
          this.props.isMobile
            ? MODAL_STYLES.mobile.generalNoPadding
            : MODAL_STYLES.desktop.generalNoPadding
        }
        onRequestClose={this.hideModal}
      >
        <ModalContainer>
          <Spacer mobile={16} desktop={16} />
          <ModalTitle>
            We need to verify your phone number
          </ModalTitle>
          <Spacer mobile={16} desktop={16} />
          { (this.props.user.phoneNumberType === 'mobile' || !this.props.user.phoneNumberType) ? (
            <>
              <ModalDiv>
                {this.state.sentCode ? (
                  <>We sent a verification code to {this.props.user.phoneNumber}. Need a different number? <MockLink onClick={this.goToDashboard}>Update it in the dashboard</MockLink>.</>
                ) : (
                  <>We'll text a verification code to {this.props.user.phoneNumber}. Need a different number? <MockLink onClick={this.goToDashboard}>Update it in the dashboard</MockLink>.</>
                )}
              </ModalDiv>
              <Spacer mobile={16} desktop={16} />
              {this.state.sentCode ? (
                <>
                  <LabeledSimpleInput
                    id="confirmationCode"
                    name="confirmationCode"
                    label="Enter your verification code"
                    value={this.state.confirmationCode}
                    onChange={this.handleConfirmationCodeChange}
                    error={this.state.errorMessage}
                  />
                  <Spacer mobile={16} desktop={16} />
                  <ButtonContainer>
                    <WinItButton
                      color="green"
                      width="100%"
                      height={70}
                      fontSize="1rem"
                      type="submit"
                      onClick={this.handleSubmit}
                    >
                      Verify
                    </WinItButton>
                  </ButtonContainer>
                </>
              ) : (
                <>
                  <ButtonContainer>
                    <WinItButton
                      color="green"
                      width="100%"
                      height={70}
                      fontSize="1rem"
                      type="submit"
                      onClick={this.sendVerificationCode}
                    >
                      Send Code
                    </WinItButton>
                  </ButtonContainer>
                </>
              )}
            </>
          ) : (
            <ModalDiv>
              Unfortunately, your phone number is not a mobile number (such as VoIP, landline, etc). Please <MockLink onClick={this.goToDashboard}>enter a valid mobile number</MockLink> or <MockLink onClick={this.goToContactSupport}>contact support</MockLink>.
            </ModalDiv>
          )}
          <Spacer mobile={16} desktop={16} />
        </ModalContainer>
      </ReactModal>
    )
  }
}

export default withRouter(PhoneVerificationModal)
